export enum Route {
  Details = '/details',
  Discover = '/discover',
  Root = '/',
  SearchResults = '/search-results',
}
